<script>
import isFunction from 'lodash/isFunction';
import CostTypeModel from '@models/CostType';
import BlockingContainer from '@components/BlockingContainer';
import editFormChange from '@mixins/editFormChange';

export default {
  components: {
    BlockingContainer,
  },
  mixins: [editFormChange],
  props: {
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
  },
  data() {
    return {
      costType: {
        name: null,
        client: null,
      },
      defaultCostType: {
        name: null,
        client: null,
      },
    };
  },
  mounted() {
    if (this.loadedId) {
      this.$wait.start('cost type loading');
      CostTypeModel.find(this.loadedId).then((response) => {
        this.costType = Object.assign({}, this.costType, response);
        this.$wait.end('cost type loading');
        this.$nextTick(() => {
          this.initChangeWatcher(['costType'], this.validate);
        });
      });
    }
  },
  methods: {
    validate(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('cost type loading');
          this.submit(callback);
        }
      });
    },
    submit(callback) {
      if (this.$route.params.id) {
        this.costType.id = this.$route.params.id;
      }
      new CostTypeModel(Object.assign({}, this.costType))
        .save()
        .then((response) => {
          this.costType = response;
          this.$emit('submitted', callback && isFunction(callback));
          if (callback && isFunction(callback)) callback();
          this.$wait.end('cost type loading');
        })
        .catch(() => this.$wait.end('cost type loading'));
    },
  },
};
</script>

<template>
  <div>
    <BlockingContainer v-if="$wait.is('cost type loading')"></BlockingContainer>
    <b-form @submit.prevent="validate">
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12">
          {{ $t('fields.name') }}:
          <span class="status-star text-danger">*</span>
        </template>
        <b-form-input
          v-model="costType.name"
          v-validate="'required|max:255'"
          data-vv-value-path="localValue"
          data-vv-name="name"
          :data-vv-as="$t('fields.name')"
          type="text"
          :state="errors.has('name') ? false : null"
          aria-describedby="input-feedback-name"
          :class="errors.has('name', 'costType-form') ? 'is-invalid' : null"
          :placeholder="$t('placeholders.name')"
        >
        </b-form-input>
        <b-form-invalid-feedback id="input-feedback-name">
          <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group>
        <template v-slot:label class="col-form-legend col-12"> {{ $t('fields.client') }}: </template>
        <b-form-checkbox v-model="costType.client" name="check-button" switch :value="1" :unchecked-value="0">
          <span class="text-light">{{ $t('fields.client') }}</span>
        </b-form-checkbox>
        <div v-show="errors.has('client', 'costType-form')" class="invalid-feedback d-block mt-1">
          {{ errors.first('client', 'costType-form') }}
        </div>
      </b-form-group>
      <b-button type="submit" :disabled="errors.any()" :variant="'outline-' + (!errors.any() ? 'dark' : 'danger')">
        {{ $t('actions.submit') }}
      </b-button>
    </b-form>
  </div>
</template>
